import { SingleTextFieldSubmit } from "@warden-ui/common-components";
import { CPCard } from "@warden-ui/common-components";
import { useTranslation } from "react-i18next";

interface CardContentTeamFindProps {
  email?: string;
  onClickFindTeam?: (email: string) => void;
  errorMessage?: string;
  loading?: boolean;
}

export const CardContentTeamFind = ({
  onClickFindTeam,
  ...props
}: CardContentTeamFindProps) => {
  const [ t ] = useTranslation();

  return (
    <CPCard>
      <SingleTextFieldSubmit
        title={t('team_find.title')}
        hint={t('team_find.hint')}
        label={t('labels.email')}
        textType="email"
        labelButton={t('buttons.next')}
        value={props.email}
        onClick={onClickFindTeam}
        errorMessage={props.errorMessage}
        loading={props.loading}
      />
    </CPCard>
  );
};
